import { createFetch } from '@vueuse/core';
import { computed, toValue } from 'vue';
import { PAGES_API } from '@/config/appConfig';

const pagesFetch = createFetch({
  baseUrl: PAGES_API,
  options: {
    async onFetchError(payload) {
      // todo: what do we want to do with any error, since this is a client's end-user facing page?
      console.log('onFetchError', payload);
      return payload;
    },
  },
});

export default () => ({
  getPage(pageId, options = {}) {
    const url = computed(() => `pages/${toValue(pageId)}`);
    return pagesFetch(url, options).get().json();
  },
  getPagePreview(pageId, options = {}) {
    const url = computed(() => `pages/${toValue(pageId)}?status=draft&ts=${Date.now()}`);
    return pagesFetch(url, options).get().json();
  },
});
